import { useSelector } from 'react-redux';

const useUpdatedUI = () => {
	const updatedUI = useSelector(state => {
		const { templates, teams, fees, scriptdates } = state;
		if (templates && templates.updated && templates.updated.length >= 1) {
			return 'templates';
		} else if (teams && teams.updated && teams.updated.length >= 1) {
			return 'teams';
		} else if (fees && fees.updated && fees.updated.length >= 1) {
			return 'fees';
		} else if (scriptdates && scriptdates.updated && scriptdates.updated.length >= 1) {
			return 'scriptdates';
		}
		return '';
	});

	return updatedUI;
};

export default useUpdatedUI;
